import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import { NotificationService } from "../services";
import { normalizeNotificationListResponse } from "../features/notifications/notification.utils";

export const fetchNotifications = createAsyncThunk("notifications/fetch", async () => {
  const response = await NotificationService.getNotifications({ page: 1, limit: 20 });
  return normalizeNotificationListResponse(response?.data || {});
});

export const markAsRead = createAsyncThunk("notifications/markAsRead", async (id: number) => {
  await NotificationService.markAsRead(id);
  return id;
});

export const markAllAsRead = createAsyncThunk("notifications/markAllAsRead", async () => {
  await NotificationService.markAllAsRead();
});

const notificationSlice = createSlice({
  name: "notifications",
  initialState: {
    items: [],
    unreadCount: 0,
    loading: false,
    lastFetchedAt: null,
    error: null,
  },
  reducers: {
    clearNotifications(state) {
      state.items = [];
      state.unreadCount = 0;
      state.lastFetchedAt = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchNotifications.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchNotifications.fulfilled, (state, action) => {
        state.items = action.payload.rows;
        state.unreadCount = action.payload.unreadCount;
        state.lastFetchedAt = Date.now();
        state.loading = false;
      })
      .addCase(fetchNotifications.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(markAsRead.fulfilled, (state, action) => {
        const item = state.items.find((n) => n.id === action.payload);
        if (item && !item.isRead) {
          item.isRead = true;
          state.unreadCount = Math.max(0, state.unreadCount - 1);
        }
      })
      .addCase(markAllAsRead.fulfilled, (state) => {
        state.items.forEach((n) => {
          n.isRead = true;
        });
        state.unreadCount = 0;
      });
  },
});

export const { clearNotifications } = notificationSlice.actions;
export default notificationSlice.reducer;
